import { useEffect, useState, useRef } from 'react';
import {
  Button,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  makeStyles,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Header from '../components/Header';
import { useHistory, useLocation } from 'react-router-dom';
import { getExams } from '../config/apiConfig';
import Notification from '../components/Notification';
import DeleteIcon from '@material-ui/icons/Delete';
import { removeAccents, formatNumber } from '../utils/helpers';

const useStyles = makeStyles((theme) => ({
  root: {
    '& label.Mui-focused': {
      color: '#A12457',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#A12457',
    },
    '& .Mui-focused': {
      color: '#A12457',
    },
    '& .MuiRadio-colorSecondary.Mui-checked': {
      color: '#A12457',
    },
  },
}));

function ExamsType() {
  const history = useHistory();
  const classes = useStyles();
  const { search } = useLocation();
  const status = new URLSearchParams(search).get('status');
  const errorCode = new URLSearchParams(search).get('errorcode');
  const test = new URLSearchParams(search).get('test');
  const [genericExam, setGenericExam] = useState('');
  const [exam, setExam] = useState('');
  const [semmMember, setSemmMember] = useState('false');
  const [exams, setExams] = useState([]);
  const [examFound, setExamFound] = useState(false);
  const [examsAndCombinationExams, setExamsAndCombinationExams] = useState([]);
  const [examsCart, setExamsCart] = useState([]);

  useEffect(() => {
    // fetch exams
    getExams().then((res) => {
      setExams(res.data);
    });
  }, []);

  const autocompleteRef = useRef();

  const handleOpenExamTypesOptions = () => {
    autocompleteRef.current.focus();
    autocompleteRef.current.querySelector('input').click();
  };

  const examPrice = (exam) => {
    if (semmMember === 'true') {
      return Number(exam?.semm_preferential_price) * 1.1;
    } else {
      return Number(exam?.price) * 1.1;
    }
  };

  const calcTotalSamplePrice = (examsCart) => {
    // From the exams in cart, we need to sum only the sample prices once
    let samplePrices = {};
    let totalPrice = 0;
    for (let item of examsCart) {
      if (!(item.sampleType.name in samplePrices)) {
        samplePrices[item.sampleType.name] = item.sampleType.price;
      }
    }
    for (let samplePrice of Object.values(samplePrices)) {
      totalPrice += Number(samplePrice);
    }
    localStorage.setItem('totalSamplePrice', totalPrice);
    return [Object.keys(samplePrices), totalPrice];
  };

  useEffect(() => {
    if (exams) {
      if (test) {
        const exam = exams.find((exam) =>
          removeAccents(exam.name)
            .toLowerCase()
            .includes(test.replace(/_/g, ' ').toLowerCase())
        );
        if (exam) {
          setGenericExam(exam);
          setExamFound(true);
        }
      }
    }
  }, [exams]);

  useEffect(() => {
    if (genericExam) {
      setExamsAndCombinationExams(
        genericExam.exams.concat(genericExam.combination_exams)
        // genericExam.exams
      );
    } else {
      setExamsAndCombinationExams([]);
    }
  }, [genericExam]);

  return (
    <>
      {localStorage.getItem('successMessage') && (
        <Notification
          type="success"
          message={localStorage.getItem('successMessage')}
          onCloseCallback={() => localStorage.removeItem('successMessage')}
        />
      )}
      {status && status == 'success' && !errorCode && (
        <Notification
          type="success"
          message="Prueba agendada con éxito"
          onCloseCallback={() => {
            localStorage.removeItem('selectedExams');
            localStorage.removeItem('selectedDate');
            localStorage.removeItem('selectedTime');
            localStorage.removeItem('isSemmMember');
            localStorage.removeItem('totalSamplePrice');
            localStorage.removeItem('paymentId');
            history.push('/type_exam_appointments');
          }}
        />
      )}

      {errorCode && (
        <Notification
          type="error"
          message="No se ha podido hacer efectivo el pago. Intente nuevamente."
          onCloseCallback={() => {
            localStorage.removeItem('selectedExams');
            localStorage.removeItem('selectedDate');
            localStorage.removeItem('selectedTime');
            localStorage.removeItem('isSemmMember');
            localStorage.removeItem('totalSamplePrice');
            localStorage.removeItem('paymentId');
            history.push('/type_exam_appointments');
          }}
        />
      )}

      <Header home />
      <Grid
        container
        direction="column"
        style={{ padding: '0 30px' }}
        spacing={1}
        lg={12}
      >
        <Grid
          container
          item
          direction="row"
          spacing={3}
          style={{ marginBottom: '10px' }}
          lg={12}
        >
          <Grid item lg={3} xs={12}>
            <Autocomplete
              ref={autocompleteRef}
              className={classes.root}
              disablePortal
              id="combo-box-demo"
              options={exams}
              getOptionLabel={(option) => option.name || ''}
              size="small"
              onChange={(_, value) => {
                setGenericExam(value);
                setExam('');
              }}
              value={genericExam}
              renderInput={(params) => (
                <TextField {...params} label="Seleccione el tipo de prueba" />
              )}
              disabled={examFound}
              openOnFocus
            />
          </Grid>
          <Grid item lg={3} xs={12}>
            <Autocomplete
              className={classes.root}
              disablePortal
              id="combo-box-demo"
              options={examsAndCombinationExams}
              getOptionLabel={(option) =>
                option.name
                  ? `${
                      option.name +
                      ' - Resultado: ' +
                      option.result_delivery_time
                    }`
                  : ''
              }
              size="small"
              onChange={(_, value) => setExam(value)}
              value={exam}
              noOptionsText="No hay opciones para la prueba seleccionada"
              renderInput={(params) => (
                <TextField {...params} label="Seleccione prueba" />
              )}
            />
          </Grid>
          <Grid item lg={6} xs={12} style={{ marginTop: '10px' }}>
            <FormControl
              className={classes.root}
              component="fieldset"
              fullWidth={true}
            >
              <Grid container direction="row">
                <Grid container item alignItems="center" lg={2}>
                  <FormLabel>¿Socio SEMM?</FormLabel>
                </Grid>
                <Grid item lg={6}>
                  <RadioGroup
                    aria-label="¿Socio SEMM?"
                    name="semmMember"
                    onChange={(event) => setSemmMember(event.target.value)}
                    defaultValue={semmMember}
                    className={classes.root}
                  >
                    <Grid container direction="row">
                      <Grid item>
                        <FormControlLabel
                          value="true"
                          control={<Radio />}
                          label="Si"
                        />
                      </Grid>
                      <Grid item>
                        <FormControlLabel
                          value="false"
                          control={<Radio />}
                          label="No"
                        />
                      </Grid>
                    </Grid>
                  </RadioGroup>
                </Grid>
              </Grid>
            </FormControl>
          </Grid>
        </Grid>
        {genericExam && (
          <Grid container lg={12} alignContent="center" justifyContent="center">
            {(genericExam?.description !== '-' ||
              (exam && exam?.extra_description != '-')) && (
              <Grid
                item
                lg={10}
                xs={12}
                style={{
                  boxShadow:
                    'rgba(50, 50, 105, 0.15) 0px 2px 5px 0px, rgba(0, 0, 0, 0.05) 0px 1px 1px 0px',
                  padding: '12px',
                  borderRadius: '10px',
                }}
              >
                <Typography variant="body2" style={{ letterSpacing: '2px' }}>
                  <strong>Descripción</strong>
                </Typography>
                <Typography variant="body2" style={{ letterSpacing: '2px' }}>
                  {genericExam?.description !== '-' && genericExam?.description}
                </Typography>
                <Typography variant="body2" style={{ letterSpacing: '2px' }}>
                  {exam?.extra_description !== '-' && exam?.extra_description}
                </Typography>
              </Grid>
            )}
            {(genericExam?.requirements !== '-' ||
              (exam && exam?.extra_requirements != '-')) && (
              <Grid
                item
                lg={10}
                xs={12}
                style={{
                  boxShadow:
                    'rgba(50, 50, 105, 0.15) 0px 2px 5px 0px, rgba(0, 0, 0, 0.05) 0px 1px 1px 0px',
                  padding: '12px',
                  borderRadius: '10px',
                }}
              >
                <Typography variant="body2" style={{ letterSpacing: '2px' }}>
                  <strong>Condiciones</strong>
                </Typography>
                <Typography variant="body2" style={{ letterSpacing: '2px' }}>
                  {genericExam?.requirements != '-' &&
                    genericExam?.requirements}
                </Typography>
                <Typography variant="body2" style={{ letterSpacing: '2px' }}>
                  {exam?.extra_requirements != '-' && exam?.extra_requirements}
                </Typography>
              </Grid>
            )}
          </Grid>
        )}
        {exam && (
          <Grid container lg={12} alignContent="center" justifyContent="center">
            <Grid
              item
              lg={10}
              style={{
                margin: '10px 0',
                boxShadow:
                  'rgba(50, 50, 105, 0.15) 0px 2px 5px 0px, rgba(0, 0, 0, 0.05) 0px 1px 1px 0px',
                padding: '12px',
                borderRadius: '10px',
                gap: '15px',
                width: '100%',
              }}
            >
              <Grid item>
                <Typography
                  variant="body2"
                  style={{
                    fontWeight: 'bold',
                    letterSpacing: '2px',
                  }}
                >
                  Resultado: {exam?.result_delivery_time || '-'}
                </Typography>
              </Grid>
              <Grid container item direction="column">
                <Grid container item direction="row">
                  <Typography variant="body2" style={{ letterSpacing: '2px' }}>
                    $
                    {semmMember === 'true'
                      ? exam?.semm_preferential_price
                        ? formatNumber(exam.semm_preferential_price)
                        : '-'
                      : exam?.price
                      ? formatNumber(exam.price)
                      : '-'}
                  </Typography>
                  <Typography variant="body2" style={{ letterSpacing: '2px' }}>
                    + 10% de IVA
                  </Typography>
                  <Typography variant="body2" style={{ letterSpacing: '2px' }}>
                    + Timbre Profesional
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              container
              item
              lg={10}
              justifyContent="flex-end"
              style={{ marginTop: '10px' }}
              height={100}
            >
              <Button
                onClick={() => {
                  setExamsCart([
                    ...examsCart,
                    { exam: exam, sampleType: genericExam.sample_type },
                  ]);
                }}
                variant="contained"
                style={{
                  letterSpacing: '1.25px',
                  fontWeight: 'bold',
                  backgroundColor: '#A12457',
                  color: 'white',
                }}
              >
                Agregar a la orden
              </Button>
            </Grid>
          </Grid>
        )}
        {!!examsCart.length && (
          <Grid
            container
            item
            direction="column"
            lg={4}
            xs={12}
            spacing={5}
            style={{
              boxShadow:
                'rgba(50, 50, 105, 0.15) 0px 2px 5px 0px, rgba(0, 0, 0, 0.05) 0px 1px 1px 0px',
              borderRadius: '10px',
              margin: '0 auto',
              padding: '28px',
              marginTop: '24px',
            }}
          >
            <Typography variant="h4" align="center">
              Resumen de la orden
            </Typography>
            <Divider />
            <Grid item>
              <ul>
                {examsCart.map((item) => (
                  <li
                    style={{
                      marginBottom: 8,
                      backgroundColor: 'rgb(161, 36, 87, 0.1)',
                      padding: 4,
                      borderRadius: 4,
                    }}
                  >
                    <b>{item.exam.name}: </b>$
                    {item.exam?.price && item.exam?.semm_preferential_price
                      ? formatNumber(examPrice(item.exam))
                      : '-'}
                    <Button
                      size="small"
                      startIcon={<DeleteIcon />}
                      variant="contained"
                      onClick={() =>
                        setExamsCart(
                          examsCart.filter((e) => e.exam !== item.exam)
                        )
                      }
                      style={{
                        fontSize: '11px',
                        fontWeight: 'bold',
                        backgroundColor: '#ff4841',
                        color: 'white',
                        marginLeft: '10px',
                        float: 'right',
                      }}
                    >
                      Quitar
                    </Button>
                  </li>
                ))}
              </ul>
            </Grid>
            <Divider />

            <Typography
              variant="body2"
              style={{
                letterSpacing: '2px',
                marginTop: '5px',
              }}
            >
              <b> Pruebas: </b> $
              {formatNumber(
                examsCart.reduce(
                  (a, b) => Number(a) + Number(examPrice(b.exam)),
                  0
                )
              )}{' '}
              IVA incluido.
            </Typography>
            <Typography
              variant="body2"
              style={{
                letterSpacing: '2px',
                marginTop: '5px',
              }}
            >
              <b>Timbre profesional:</b> $
              {formatNumber(calcTotalSamplePrice(examsCart)[1])}
            </Typography>
            <Typography
              variant="h6"
              style={{ marginTop: '10px', letterSpacing: '2px' }}
            >
              <b>
                Total: $
                {formatNumber(
                  examsCart.reduce(
                    (a, b) => Number(a) + Number(examPrice(b.exam)),
                    0
                  ) + calcTotalSamplePrice(examsCart)[1]
                )}
              </b>
            </Typography>
            <Grid
              container
              direction="row"
              justifyContent="flex-end"
              alignItems="flex-end"
              spacing={2}
            >
              <Grid item>
                <Button
                  onClick={handleOpenExamTypesOptions}
                  variant="contained"
                  style={{
                    letterSpacing: '1.25px',
                    fontWeight: 'bold',
                    backgroundColor: '#A12457',
                    color: 'white',
                  }}
                >
                  Agregar otra prueba
                </Button>
              </Grid>
              <Grid item>
                <Button
                  onClick={() => {
                    localStorage.setItem(
                      'selectedExams',
                      JSON.stringify(examsCart)
                    );
                    localStorage.setItem('isSemmMember', semmMember);
                    history.push('/schedule_exam_appointments');
                  }}
                  variant="contained"
                  style={{
                    letterSpacing: '1.25px',
                    fontWeight: 'bold',
                    backgroundColor: '#A12457',
                    color: 'white',
                    marginTop: '15px',
                  }}
                >
                  Agendar
                </Button>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>
    </>
  );
}

export default ExamsType;
